import { handleActions } from "redux-actions";
import * as apiActions from "../actions";

const defaultState = {
  error: "",
  pieChart: [],
  trendchart: [],
  defaultProject: { projects: [], suitypes: [], dates: [] },
  report: { pie: [], trend: [], table: [] },
  defaultPieChart:{}
};

export const automationAnalytics = handleActions(
  {
    [apiActions.projectSuccess]: (state, action) => ({
      ...state,
      defaultProject: { ...state.defaultProject, projects: action.payload },
    }),
    [apiActions.defaultPieChartSuccess]: (state, action) => ({
      ...state,
      defaultPieChart:  action.payload 
    }),
    [apiActions.suitTypeSuccess]: (state, action) => ({
      ...state,
      defaultProject: { ...state.defaultProject, suitypes: action.payload },
    }),
    [apiActions.dateSuccess]: (state, action) => ({
      ...state,
      defaultProject: { ...state.defaultProject, dates: action.payload },
    }),
    [apiActions.reportPieCharSuccess]: (state, action) => {
      return {
        ...state,
        report: { ...state.report, pie: action.payload },
      };
    },

    [apiActions.reportTrendCharSuccess]: (state, action) => {
      return {
        ...state,
        report: { ...state.report, trend: action.payload },
      };
    },
    [apiActions.reportTableCharSuccess]: (state, action) => {
      return {
        ...state,
        report: { ...state.report, table: action.payload },
      };
    },
    [apiActions.reportClearData]: (state, action) => {
      return {
        ...state,
        report: { ...state.report, trend: [] },
      };
    },
    //  [apiActions.trendchartBulkSuccess]: (state, action) => {
    //   return {
    //    ...state,
    //   trendchartBulk: action.payload
    //  }
    // },
    // [apiActions.userinfomationSuccess]: (state, action) => {
    //   return {
    //     ...state,
    //    user: action.payload
    //   }
    //  },
    // [apiActions.testCasesSuccess]: (state, action) => {
    //   return {
    //     ...state,
    //     testCases: action.payload
    //   };
    // },
  },
  defaultState
);
